import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { FunctionComponent } from "react";

/** Information of an integration */
export interface IntegrationInfo {
  /** The human readable name of an integration */
  displayName: string;

  /** The description of an integration */
  description: string;

  /** The icon of an integration */
  icon: FunctionComponent;
}

/** State of the project-level integration dialog */
export type ProjectLevelIntegrationDialog =
  | "connected"
  | "connect"
  | "disconnect"
  | "userConnection"
  | "none";

/** State of the user-level integration dialog */
export type UserLevelIntegrationDialog =
  | "inProgress"
  | "disconnect"
  | "success"
  | "none";

/** Callbacks for the integration dialogs  */
export interface IntegrationDialogCallbacks {
  /** Callback when confirm button clicked on success dialog */
  onSuccessDialogConfirm(): void;

  /** Callback when cancel button clicked on in progress dialog */
  onInProgressDialogCancel(): void;

  /** Callback when confirm button clicked on disconnect dialog */
  onDisconnectDialogConfirm(): void;

  /** Callback when cancel button clicked on disconnect dialog */
  onDisconnectDialogCancel(): void;
}

/** Props for the integration dialogs */
export interface IntegrationDialogProps {
  /** Callback when the dialog is confirmed */
  dialogConfirmCallback?: () => void | Promise<void>;

  /** Callback when the dialog is canceled */
  dialogCancelCallback?: () => void;

  /** Integration ID */
  integrationId: FaroCoreApiTypes.IntegrationId;
}

/** Component or page from where the user=level integration connection is triggered */
export enum IntegrationUserConnectionOrigin {
  integrationAccounts = "integration accounts page",
  projectIntegrations = "project integrations page",
}
